import {Dimension} from "./dimension";
import {getUniqueFloatArray} from "../../utils/utils";
import {sortFloatArray} from "../../utils/mathUtils";
import {Vector3, Box3} from "three";

const measurementsY = 5;

export class WorkingMeasurement {
    constructor(wallX, wallZ, posX, posZ, orientationX, orientationZ, measureGroup) {
            this.posX = posX;
            this.posZ = posZ;
            this.boundsX = new Box3().setFromObject(wallX);
            this.boundsZ = new Box3().setFromObject(wallZ);
            this.measureGroup = measureGroup;
            this.orientationX = orientationX;
            this.orientationZ = orientationZ;
            this.createOutSideMeasurement();        
    }

    //Outside measurements functions
    createOutSideMeasurement() {
        let pointsX = [this.boundsX.min.x, this.boundsX.max.x];
        let pointsZ = [this.boundsZ.min.z, this.boundsZ.max.z];

        let dimensionX = this.createMeasurementFor(pointsX, /*useX*/true);
        let dimensionY = this.createMeasurementFor(pointsZ, /*useX*/false);

        this.positionDimension(dimensionX, dimensionY);

        this.measureGroup.addWithUuid(dimensionX);
        this.measureGroup.addWithUuid(dimensionY);
    }

    //Utils
    positionDimension(dimensionX, dimentsionY) {
        let posZOffset = 0;
        let posXOffset = 0;
        
        if (this.posZ.z > this.boundsX.min.z && this.posZ.z < this.boundsX.max.z && this.orientationZ == 'x') {
            //When measurement line is inside the boundaries of the measured cutout/wall (horizontal)
            posZOffset = 0.4; //Add offset to z dimension
        } else if (this.posZ.x > this.boundsZ.min.x && this.posZ.x < this.boundsZ.max.x && this.orientationX == 'z') {
            //When measurement line is inside the boundaries of the measured cutout/wall (vertical)
            posXOffset = 0.4; //Add offset to x dimension
        } else if (this.orientationX == 'z' && this.orientationZ == 'z') {
                posXOffset = 0.4;
        }

        dimensionX.position.set(0, measurementsY, this.posZ.z+posZOffset);
        dimentsionY.position.set(this.posX.x+posXOffset, measurementsY, 0);
    }

    createMeasurementFor(points, useX) {
        points = this.filterAndSortDimensionPoints(points);

        let dimension = new Dimension(points, !useX, this.scaleFactor);

        if (!useX) {
            dimension.rotateY(Math.PI / 2);
        }

        return dimension;
    }

    filterAndSortDimensionPoints(points) {
        points = getUniqueFloatArray(points);
        return sortFloatArray(points);
    }
}
